import SEO from '../components/SEO';

const usageItems = [
  "All photography, motion assets, copy, logos, and design systems displayed on letsfaceit.studio belong to Let's Face It Studio unless otherwise credited.",
  "Client galleries shared privately remain confidential and should not be reposted without written consent from all featured parties.",
  "Editorial placements or press pulls featuring our work must credit the studio and lead artist in the final listing or caption.",
];

const requestSteps = [
  "Email hello@letsfaceitcosmetics.com with the asset you'd like to feature and how it will be used.",
  "We'll confirm any crediting language, timing, or licensing fees within three business days.",
  "Once approved, we'll deliver the correct files or connect you with the photographer for final permissions.",
];

export default function Copyright() {
  return (
    <>
      <SEO
        title="Copyright & Credits"
        description="Copyright guidelines for Let's Face It Studio content. Learn how to properly credit and request permission to use our work."
        canonical="https://letsfaceitcosmetics.com/copyright"
      />
      <section className="fixed top-0 left-0 h-full w-full overflow-y-auto bg-gradient-to-b from-[#f1ede7] via-[#ece6de] to-[#e4ded4] text-[#161616] mt-[70px] md:mt-[100px] pb-20 md:pb-32 lg:pb-36">
        <div className="mx-auto max-w-3xl px-4 py-11 xsm:py-[58px] sm:py-[85px] sm:px-8">
          <header className="space-y-4 text-center">
            <span className="text-xs uppercase tracking-[0.4em] text-[#5b5141]">Copyright & Credits</span>
            <h1 className="font-mak text-4xl leading-tight text-[#1b1b1b] sm:text-5xl mt-4">
              Artistry deserves proper credit.
            </h1>
            <p className="text-[18px] leading-relaxed text-[#3c3c3c] sm:text-xl">
              Every image, film clip, and phrase on this site represents artists and collaborators we respect. Use the guidance below when featuring our work.
            </p>
          </header>

          <div className="mt-10 space-y-10">
            <article className="space-y-3">
              <h2 className="text-sm font-semibold uppercase tracking-[0.3em] text-[#5b5141]">Usage Guidelines</h2>
              <ul className="list-disc space-y-2 pl-5 text-base leading-relaxed text-[#3c3c3c]">
                {usageItems.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            </article>

            <article className="space-y-3">
              <h2 className="text-sm font-semibold uppercase tracking-[0.3em] text-[#5b5141]">How to Request Permission</h2>
              <ol className="list-decimal space-y-2 pl-5 text-base leading-relaxed text-[#3c3c3c]">
                {requestSteps.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ol>
            </article>

            <article className="space-y-3">
              <h2 className="text-sm font-semibold uppercase tracking-[0.3em] text-[#5b5141]">Attribution Language</h2>
              <p className="text-base leading-relaxed text-[#3c3c3c]">
                Reference the studio as <span className="font-semibold text-[#1b1b1b]">"Let's Face It Studio - Luxury Makeup Artistry"</span>
                {" "}and include the lead artist when known. Example credit: "Makeup by Let's Face It Studio / Artist: Jamie Connelly."
              </p>
            </article>
          </div>

          <footer className="mt-12 border-t border-[#d9cbb8] pt-6 text-left text-sm text-[#3c3c3c] sm:text-base">
            Questions about usage rights? Email{" "}
            <a href="mailto:hello@letsfaceitcosmetics.com" className="underline decoration-[#cbbda9] decoration-2 underline-offset-4">
              hello@letsfaceitcosmetics.com
            </a>{" "}
            and we'll clarify within one business day.
          </footer>
        </div>
      </section>
    </>
  );
}
